import { Controller } from "@hotwired/stimulus"

/**
 * Window Controller - Handles window-related JavaScript functions
 */
export default class extends Controller {
  static targets = ["button"]

  connect() {
    // Initialize any necessary state when the controller connects
  }

  openPrint(event) {
    event.preventDefault()
    window.print()
  }

  print() {
    window.print()
  }

  downloadTemplate(event) {
    event.preventDefault()
    
    // Create a temporary link for downloading the template
    const link = document.createElement('a')
    link.href = '/templates/quote_bundle_template.xlsx'
    link.download = 'quote_bundle_template.xlsx'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  focusElement(event) {
    event.preventDefault()
    const selector = this.element.dataset.windowSelector
    if (selector) {
      const element = document.querySelector(selector)
      if (element) {
        element.focus()
      }
    }
  }
}